import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IFormManifestationDetermination } from "../../../../Models/Forms/IFormManifestationDetermination";
import { FormManifestationDeterminationService } from "../../../../Services/FormManifestationDeterminationService";
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { IInitialIEPInfo } from '../../../../Models/IInitialIEPInfo';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { ILookupBase } from '../../../../Models/ILookupBase';
import { Router } from "@angular/router";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'ManifestationDetermination',
  templateUrl: './ManifestationDetermination.component.html',
  styleUrls: ['./ManifestationDetermination.component.css']
})

export class FormManifestationDeterminationComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  initialIepInfo: IInitialIEPInfo;
  staffList: ILookupBase[];
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  manifestationDisability: boolean;
  manifestationDeterminationDB: any = [];
  reportParamArray: IReportParameter[];
  checkedTrue: Boolean = true;
  checkedFale: Boolean = false;
  oneYearBackDate: Date;
  //public showSpinner: boolean = false;

  constructor
    (
      private globals: Globals, reportService: ReportService,
      private _formManifestationDeterminationService: FormManifestationDeterminationService,
      iepService: IepService,
      @Inject('BASE_URL') baseUrl: string,
      public router: Router) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
  }

  ngOnInit(): void {
    this.LoadLastEvalDate();
    this.LoadFormManifestationDeterminationDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.manifestationDisability = null;
    this.PopulateLookupData();
    this.scrollToTop();
    this.successMessages = [];
    this.errorMessages = [];
    let myDate = this._myGlobals.selectedIepInstance.meetingDate;
    this.oneYearBackDate = new Date(myDate.getFullYear() - 1, myDate.getMonth(), myDate.getDate());
  }

  LoadLastEvalDate() {
    this._iepService.getInitialIepInfo(this._baseUrl + 'api/InitialIEPInfo/' + this.studentInfo.localStudentId).subscribe((res: IInitialIEPInfo) => {
      this.initialIepInfo = res
    },
      err => console.error(err)
    );
  }

  PopulateLookupData() {
    this._formManifestationDeterminationService.getServiceProviderList().subscribe((res: ILookupBase[]) => {
      this.staffList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );
  }

  LoadFormManifestationDeterminationDetails(): void {
    this._formManifestationDeterminationService.getFormManifestationDetermination(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormManifestationDetermination) => {
        this.manifestationDeterminationDB = res
        if (this.manifestationDeterminationDB.signatureDate1 != null) {
          this.manifestationDeterminationDB.signatureDate1 = new Date(this.manifestationDeterminationDB.signatureDate1);
        }
        if (this.manifestationDeterminationDB.signatureDate2 != null) {
          this.manifestationDeterminationDB.signatureDate2 = new Date(this.manifestationDeterminationDB.signatureDate2);
        }
        if (this.manifestationDeterminationDB.manifistationDate != null) {
          this.manifestationDeterminationDB.manifistationDate = new Date(this.manifestationDeterminationDB.manifistationDate);
        }
        if (this.manifestationDeterminationDB.disciplinaryActionDecisionDate != null) {
          this.manifestationDeterminationDB.disciplinaryActionDecisionDate = new Date(this.manifestationDeterminationDB.disciplinaryActionDecisionDate);
        }
        if (this.manifestationDeterminationDB.parentReceiveCopyOfProceduralSafeguardsDate != null) {
          this.manifestationDeterminationDB.parentReceiveCopyOfProceduralSafeguardsDate = new Date(this.manifestationDeterminationDB.parentReceiveCopyOfProceduralSafeguardsDate);
        }
      },
        err => console.error(err)
      );
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  //Save the Manifestation Determination
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values
    this._formManifestationDeterminationService.insertUpdateFormManifestationDetermination(this.manifestationDeterminationDB)
      .subscribe((res: IFormManifestationDetermination) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.validateForm();
        this.LoadFormManifestationDeterminationDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  validateForm() {
    this._formManifestationDeterminationService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormManifestationDeterminationDetails();
  }


  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False'  },
      { parameterName: 'FormInstanceID', parameterValue: this.manifestationDeterminationDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'ReportPath', parameterValue: this.manifestationDeterminationDB.rdlFileNameEnglish }
    );
  } 

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.manifestationDeterminationDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.manifestationDeterminationDB.rdlFileNameSpanish, this.reportParamArray);
  }

  onManifestationDisabilityClicked() {
    if (this.manifestationDisability === true) {
      this.manifestationDeterminationDB.wasNotManifestationOfDisabilityComments = '';
    }
    else if (this.manifestationDisability === false) {
      this.manifestationDeterminationDB.isFunctionalBehavionAssessmentToBeConducted = false;
      this.manifestationDeterminationDB.isBehaviorPlanToBeModiified = false;
      this.manifestationDeterminationDB.wasManifestationOfDisabilityComments = ''
    }
  }
}
